import { render, staticRenderFns } from "./MrfReport.vue?vue&type=template&id=3642fde4"
import script from "./MrfReport.vue?vue&type=script&lang=js"
export * from "./MrfReport.vue?vue&type=script&lang=js"
import style0 from "./MrfReport.vue?vue&type=style&index=0&id=3642fde4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports